import { VuexModule, Module, MutationAction } from "vuex-module-decorators";
import { FeatureMap } from "../../models/FeatureMap";

@Module({ namespaced: false })
class Features extends VuexModule {
  /**
   *
   */
  constructor(model: never) {
    super(model);
    if (localStorage.features)
      this._features = {
        ...this._features,
        ...JSON.parse(localStorage.features),
      };
  }

  _features: FeatureMap = {
    Facematch: false,
    SaveJWT: false,
    TimeLine: false,
  };

  @MutationAction({ mutate: ["_features"] })
  setFeatures(
    features: Partial<FeatureMap>
  ): Promise<{ _features: FeatureMap }> {
    const _features: FeatureMap = { ...this._features, ...features };
    localStorage.features = JSON.stringify(_features);
    return Promise.resolve<{ _features: FeatureMap }>({ _features });
  }

  get features(): FeatureMap {
    return this._features;
  }
}

export default Features;
